import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  SystemMainSettings,
  UpdateSystemSettingCommand,
} from 'src/app/core/api/models';
import { SystemSettingsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppSystemSettingForm } from 'src/app/core/types/app-system-setting-form.type';
import { CreateSystemSettingCommand } from '../../../../core/api/models/create-system-setting-command';
import { SettingDto } from '../../../../core/api/models/setting-dto';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-system-setting-form',
    templateUrl: './system-setting-form.component.html',
    styleUrls: ['./system-setting-form.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class SystemSettingFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  formPageConfig: FormPageConfig<SettingDto> = {};
  model: CreateSystemSettingCommand = {};
  showPrivateNumbers: boolean = false;
  showRoles: boolean = false;
  showUserGroupPriceCategory: boolean = false;
  isShowNumberInput: boolean = false;
  isShowPercentInput: boolean = false;

  numberValue: number;
  selectedId: number = -1;
  hasCurrency: boolean = false;
  protected currentService = inject(SystemSettingsService);

  //#endregion

  constructor(
    private dialogRef: MatDialogRef<SystemSettingFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.formPageConfig.vocabs = data?.pageVocab;

    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    try {
      this.initForm();
      this.initModel();
      this.getUserState();
      this.changeFormValidations();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initModel(): void {
    try {
      this.selectedId = -1;
      this.onChangeKey(this.model.key);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      key: new FormControl('', Validators.required),
      value: new FormControl('', [Validators.required]),
    });
  }

  changeFormValidations() {
    try {
      if (this.formPageConfig.isEditMode) {
        this.form.controls['key'].disable();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateSystemSettingCommand) {
    this.unSubs();
    this.loading = true;
    model.value = model.value.toString();
    this.currentService
      .systemSettingsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateSystemSettingCommand) {
    this.unSubs();

    this.loading = true;
    this.currentService
      .systemSettingsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion
  onChangeKey(key: SystemMainSettings) {
    try {
      this.model.key = key;
      if (key == SystemMainSettings.DefaultPanelPrivateNumber) {
        this.showRoles = false;
        this.showUserGroupPriceCategory = false;
        this.isShowNumberInput = false;
        this.isShowPercentInput = false;
        this.showPrivateNumbers = true;
        // } else if (key == SystemMainSettings.NewUserRole) {
        //   this.showPrivateNumbers = false;
        //   this.showUserGroupPriceCategory = false;
        //   this.isShowNumberInput = false;
        //   this.isShowPercentInput = false;
        //   this.showRoles = true;
        // } else if (key == SystemMainSettings.NewUserGroupPriceCategory) {
        //   this.showPrivateNumbers = false;
        //   this.showRoles = false;
        //   this.isShowNumberInput = false;
        //   this.isShowPercentInput = false;
        //   this.showUserGroupPriceCategory = true;
      } else if (
        key == SystemMainSettings.MinimumOnlineAmount ||
        key == SystemMainSettings.ResolutionOfParliament ||
        key == SystemMainSettings.FixedFloorNumberOfSendSmartSmsRequest ||
        key == SystemMainSettings.MaximumCreateSmartSmsRequestWithoutSendPerDay
      ) {
        if (
          key == SystemMainSettings.FixedFloorNumberOfSendSmartSmsRequest ||
          key ==
            SystemMainSettings.MaximumCreateSmartSmsRequestWithoutSendPerDay
        )
          this.hasCurrency = false;
        else this.hasCurrency = true;

        this.showPrivateNumbers = false;
        this.showRoles = false;
        this.showUserGroupPriceCategory = false;
        this.isShowNumberInput = true;
        this.isShowPercentInput = false;
      } else if (
        key == SystemMainSettings.Tax ||
        key ==
          SystemMainSettings.MinimumPercentOfSendSmartSmsRequestUntilFixedFloorNumber
      ) {
        this.showPrivateNumbers = false;
        this.showRoles = false;
        this.showUserGroupPriceCategory = false;
        this.hasCurrency = true;
        this.isShowNumberInput = false;
        this.isShowPercentInput = true;
      } else {
        this.showPrivateNumbers = false;
        this.showRoles = false;
        this.showUserGroupPriceCategory = false;
        this.isShowNumberInput = false;
        this.isShowPercentInput = false;
      }
      if (this.formPageConfig.isEditMode) {
        this.selectedId = Number(this.model.value);
        this.numberValue = Number(this.model.value);
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  changeValue(event, type: AppSystemSettingForm) {
    try {
      if (type == 'privateNumber') this.model.value = event.id.toString();
      else if (type == 'role') this.model.value = event.key;
      else if (type == 'number') this.model.value = event;
      else this.model.value = event.id;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
